import React, { useContext } from 'react';
import {
  shape, string, arrayOf, func, bool
} from 'prop-types';
import classNames from 'classnames';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';

export const CategoryFilter = ({ onClick, category, showMobileCardTabs }) => {
  const {
    channel,
  } = useContext(ExperienceContext);

  const irgFilterButtonClass = classNames(
    'item-related-groups__filters__button',
    { 'item-related-groups__filters__button--mobile': (channel === 'mobile' && !showMobileCardTabs) }
  );

  return (
    <button
      type="button"
      className={irgFilterButtonClass}
      key={category.subCategory}
      onClick={() => { onClick({ category }); }}
    >
      {channel !== 'mobile' && category?.categoryImage
        ? <img alt={category.categoryImage} src={category.categoryImage} />
        : null}
      <span>
        {category.subCategory}
      </span>
      <span>({category.itemIds.length})</span>
    </button>
  );
};

CategoryFilter.propTypes = {
  category: shape({
    subCategory: string,
    itemIds: arrayOf(string)
  }).isRequired,
  onClick: func,
  showMobileCardTabs: bool
};

CategoryFilter.defaultProps = {
  onClick: () => {},
  showMobileCardTabs: false
};
